import moment from 'moment'

/**
 * Formata valor como data no padrão brasileiro (DD/MM/YYYY).
 */
export function formatDateBR(value) {
  if (value === null || value === undefined || value === '') return ''
  const m = moment(value)
  return m.isValid() ? m.format('DD/MM/YYYY') : ''
}

/**
 * Formata valor como data e hora (DD/MM/YYYY HH:mm).
 */
export function formatDateTimeBR(value) {
  if (value === null || value === undefined || value === '') return ''
  const m = moment(value)
  return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : ''
}
